import { AtTagProps, AtTagType } from "./at-tag.types";
import {
  TagCampaigns,
  TagFolio,
  TagAccounts,
  TagNumber,
  TagOrganization,
  TagNote,
} from "./components";
import { GlobalChipStyles } from "../../../theme/global-styles";

export const AtTag = (props: AtTagProps) => {
  const { type } = props;

  const renderTag = () => {
    switch (type) {
      case AtTagType.CAMPAIGNS:
        return <TagCampaigns {...props} />;
      case AtTagType.FOLIO:
        return <TagFolio {...props} />;
      case AtTagType.ACCOUNTS:
        return <TagAccounts {...props} />;
      case AtTagType.NUMBER:
        return <TagNumber {...props} />;
      case AtTagType.ORGANIZATION:
        return <TagOrganization {...props} />;
      case AtTagType.NOTE:
        return <TagNote {...props} />;
    }
  };

  return (
    <>
      <GlobalChipStyles />
      {renderTag()}
    </>
  );
};
